export const allowedDocStatus = {
  defaultAllowedDocStatus: [
    "DRAFT",
    "NOT SUBMITTED"
  ],
  spainAllowedDocStatus: [
    "DRAFT",
    "NOT SUBMITTED",
    "REVIEWED WITH MINOR CHANGES",
    "APPROVED WITH MINOR CHANGES",
  ],
  israelAllowedDocStatus: [
    "DRAFT",
    "NOT SUBMITTED",
    "REVIEWED WITH MINOR CHANGES",
    "APPROVED WITH MINOR CHANGES",
  ],
  greeceAllowedDocStatus: [
    "DRAFT",
    "NOT SUBMITTED",
    "REVIEWED WITH MINOR CHANGES",
    "APPROVED WITH MINOR CHANGES",
  ],
  switzerlandAllowedDocStatus: [
    "DRAFT",
    "NOT SUBMITTED",
    "REVIEWED WITH MINOR CHANGES",
    "APPROVED WITH MINOR CHANGES",
  ],
  franceAllowedDocStatus: [
    "NOT SUBMITTED",
    "DRAFT",
    "REVIEW COMPLETE",
    "PENDING HEALTH AUTHORITY SUBMISSION",
    "APPROVED FOR PRODUCTION",
  ],
  usMarketAllowedDocStatus: [
    "NOT SUBMITTED",
    "DRAFT",
    "BUSINESS OWNER REVIEW COMPLETE",
    "AWC: AGENCY UPDATES",
    "AWC: VALIDATE CHANGES (BUSINESS OWNER)",
    "REVISE AND RESUBMIT FOR REVIEW",
    "APPROVED WITHOUT SUBMISSION",
    "REVISE AND RESUBMIT FOR FINAL APPROVAL",
  ],
}

export const allowedProductList = {
  usMarketAllowedProductList: [
    "BIKTARVY",
    "TRODELVY",
    "YESCARTA",
  ],
  israelAllowedProductList: [
    "BIKTARVY",
    "TRODELVY",
  ],
  greeceAllowedProductList: [
    "BIKTARVY",
    "TRODELVY",
  ],
  switzerlandAllowedProductList: [
    "BIKTARVY",
    "TRODELVY",
  ],
}

export const getColor = (status) => {
  if (status === "Approved for Use" || "Available for Use") return "#E1EDDA";
  if (status === ("Draft" || "Expired" || "Withdrawn")) return "#F0F0F0";
  if (status === ("In Business Owner Review" || "Approval Complete" || "Librarian QC")) return "#FDE9DF";
  return "";
};

export const findCountry = (countriesList, countryId, countryName) => {
  if(countryId) {
    return countriesList?.find(
      ({ _id, name }) => _id === countryId && name === countryName
    );
  }
 return null
};

export const findBrand = (brands, brandId, brandName) => {
  if(brandId) {
    return  brands?.find(
      ({ _id }) => _id === brandId
    )?.name;
  } else if(brandName) {
    return brands?.find(
      ({ name }) => name === brandName
    )?._id;
  }
 return null
};
